<!-- custom selects - con validation form o no -->
<!-- <div class="custom-container-select w-full" *ngIf="!parentForm">
  <ion-select
    [placeholder]="placeholder"
    mode="ios"
    lines="none"
    interface="popover"
    (ionChange)="onSelectChange($event)"
    [interfaceOptions]="{ cssClass: customClass }"
  >
    <ion-select-option
      *ngFor="let option of selectOptions"
      [value]="option"
      mode="ios"
      class="text-sm"
    >
      {{ option }}
    </ion-select-option>
  </ion-select>
</div>
<div  *ngIf="parentForm"
  class="custom-container-select w-full"
  [formGroup]="parentForm"
>
  <ion-select
    [formControlName]="parentFormControlName"
    [placeholder]="placeholder"
    mode="ios"
    lines="none"
    interface="popover"
    (ionChange)="onSelectChange($event)"
    [interfaceOptions]="{ cssClass: customClass }"
  >
    <ion-select-option
      *ngFor="let option of selectOptions"
      [value]="option"
      mode="ios"
      class="text-sm"
    >
      {{ option }}
    </ion-select-option>
  </ion-select>
</div> -->

<!-- <label id="listbox-label" class="block text-sm font-medium leading-6 text-gray-900">Assigned to</label> -->
<div
	*ngIf="!parentForm"
	appClickedOutside
	(clickedOutside)="handleClickedOutside()"
	class="relative dropdown-select"
>
	<button
		(click)="toggleOpen()"
		type="button"
		[disabled]="disabled"
		[class.cursor-pointer]="!disabled"
		class="relative w-full rounded-md bg-white pl-3 pr-10 text-left text-gray-900 shadow-sm border-gray sm:text-sm sm:leading-6"
	>
		<!-- <span class="flex items-center">
      <span class="block truncate" [ngClass]="{'desempeno-secondary-text': !selectedValue}" >{{selectedValue ? selectedValue : placeholder}}</span>
    </span> -->
		<ion-input [value]="selectedValue" [placeholder]="placeholder" [readonly]="true"></ion-input>
		<span class="absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
			<ion-icon
				[ngClass]="{ 'rotate-180': openSelect, 'rotate-0': !openSelect }"
				class="transition-transform duration-200 transform"
				name="chevron-down-outline"
			></ion-icon>
		</span>
	</button>

	<ul
		*ngIf="openSelect"
		class="max-h-50 absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg border-gray sm:text-sm"
	>
		<li
			*ngFor="let option of selectOptions"
			(click)="onSelectedOption(option)"
			[ngClass]="{ 'hover-cursalab-color': optionHoverColor === 'cursalab-color' }"
			class="text-gray-900 relative cursor-default select-none py-2 px-3"
		>
			<div class="flex items-center">
				<span class="font-normal block truncate">{{ option }} </span>
			</div>
		</li>
	</ul>
</div>

<div
	class="relative dropdown-select"
	*ngIf="parentForm"
	[formGroup]="parentForm"
	appClickedOutside
	(clickedOutside)="handleClickedOutside()"
>
	<button
		(click)="toggleOpen()"
		type="button"
		[disabled]="disabled"
		[class.cursor-pointer]="!disabled"
		class="relative w-full rounded-md bg-white  pl-3 pr-10 text-left text-gray-900 shadow-sm border-gray sm:text-sm sm:leading-6"
	>
		<!-- <span class="flex items-center">
      <span class="block truncate" [ngClass]="{'desempeno-secondary-text': !selectedValue}" >{{selectedValue ? selectedValue : placeholder}}</span>
    </span> -->
		<ion-input
			[formControlName]="parentFormControlName"
			[value]="selectedValue"
			[placeholder]="placeholder"
			[readonly]="true"
		></ion-input>
		<span class="absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
			<ion-icon
				[ngClass]="{ 'rotate-180': openSelect, 'rotate-0': !openSelect }"
				class="transition-transform duration-200 transform"
				name="chevron-down-outline"
			></ion-icon>
		</span>
	</button>

	<ul
		*ngIf="openSelect"
		class="max-h-50 absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg border-gray sm:text-sm"
	>
		<li
			*ngFor="let option of selectOptions"
			(click)="onSelectedOption(option)"
			[ngClass]="{ 'hover-cursalab-color': optionHoverColor === 'cursalab-color' }"
			class="text-gray-900 relative cursor-default select-none py-2 pl-3 pr-9"
			id="listbox-option-0"
		>
			<div class="flex items-center">
				<span class="font-normal block truncate">{{ option }} </span>
			</div>
		</li>
	</ul>
</div>
